module.exports = __webpack_public_path__ + "img/Moduuli_2_liiketoimintamalli_liikevaihtopotentiaali.5a53cb9f.png";